import { Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMultipleDocketNumberSelector extends Layout {
    labelPrompt: Label;
    panelSelector: Panel;
    textboxDocketNumber: Textbox;
    textboxDotNumber: Textbox;
}
